export default "__VITE_ASSET__BT37y0DL__"